/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useProductQR = () => {
  let barcode, orgid, uniqueid;
  let urlParams = window.location.href;
  // let params = urlParams.split('/');
  // console.log(`url in provider:`, params[params?.length - 1]);
  // let id = decodeURIComponent(params[params?.length - 1]);
  // if (id) {
  //   id = String(id).trim();
  //   return id;
  // }
  let url = new URL(urlParams);
  console.log(`on useProductQR -> url in provider:`, url);
  let params = url.pathname?.split('/').filter(param => param) ?? [];
  console.log(`on useProductQR -> params url in provider:`, params);
  if (params?.length == 2 && params[0]?.length == 5) {
    orgid = params[0];
    uniqueid = params[1];
  } else if (params?.length > 0) {
    barcode = params[params?.length - 1];
  }
  console.log(`on useProductQR -> barcode: ${barcode}, orgid: ${orgid}, uniqueid: ${uniqueid}`);
  return { barcode, orgid, uniqueid };
};
